import { GoDotFill } from "react-icons/go";
import { HiOutlinePlus } from "react-icons/hi";
import { BsArrowRight } from "react-icons/bs";
import { TbEqual, TbMinusVertical, TbAsteriskSimple } from "react-icons/tb";
import { IoSquareOutline, IoTriangleOutline } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";

import "./styles.scss";

export type SelectionType =
	| "electrodes"
	| "venepuncture"
	| "surgical-incision"
	| "surgical-drains"
	| "scalpel-plate"
	| "oximeter"
	| "cushion"
	| "clamp";

export type SelectionTypeWithTrash = SelectionType | "trash";

type EventCallback = (type: SelectionTypeWithTrash) => void;

export type HumanBodySelectionTypesMenuProps = {
	selectionTypes: SelectionType[] | "all";
	onSelectType?: EventCallback;
	onMouseEnter?: EventCallback;
	onMouseLeave?: EventCallback;
};

export const typeRenderers = {
	electrodes: <GoDotFill />,
	venepuncture: <BsArrowRight />,
	"surgical-incision": <TbMinusVertical />,
	"surgical-drains": <HiOutlinePlus />,
	"scalpel-plate": <TbEqual />,
	oximeter: <TbAsteriskSimple />,
	cushion: <IoSquareOutline />,
	clamp: <IoTriangleOutline />,
};

export function HumanBodySelectionTypesMenu({
	selectionTypes,
	onSelectType,
	onMouseEnter,
	onMouseLeave,
}: HumanBodySelectionTypesMenuProps) {
	function renderSelectionType(type?: SelectionType) {
		if (!type) {
			return <span className="fs-5">?</span>;
		}

		return typeRenderers[type];
	}

	return (
		<section className="human-body-selection-types-menu">
			{Array.from({ length: 8 }, (_, index) => {
				const type = Array.isArray(selectionTypes)
					? selectionTypes[index]
					: (Object.keys(typeRenderers)[index] as SelectionType);

				const selectionTypeClassName = `selection-type ${type ? "active" : "inactive"}`;

				const activeProps = {
					onMouseEnter: () => onMouseEnter?.(type),
					onMouseLeave: () => onMouseLeave?.(type),
					onClick: () => onSelectType?.(type),
				};

				return (
					<div
						className={selectionTypeClassName}
						key={`selection-type-${index}`}
						{...(type ? activeProps : {})}
					>
						<span className="fs-5">{renderSelectionType(type)}</span>
					</div>
				);
			})}

			<div className="selection-type active" onClick={() => onSelectType?.("trash")}>
				<span className="fs-5">
					<FiTrash2 />
				</span>
			</div>
		</section>
	);
}
